import { render } from "./ScheduleTherapy.vue?vue&type=template&id=0f3771ff&ts=true"
import script from "./ScheduleTherapy.vue?vue&type=script&lang=ts"
export * from "./ScheduleTherapy.vue?vue&type=script&lang=ts"

import "./ScheduleTherapy.vue?vue&type=style&index=0&id=0f3771ff&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/PatientDetail/ScheduleTherapy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f3771ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f3771ff', __exports__)) {
    api.reload('0f3771ff', __exports__)
  }
  
  module.hot.accept("./ScheduleTherapy.vue?vue&type=template&id=0f3771ff&ts=true", () => {
    api.rerender('0f3771ff', render)
  })

}


export default __exports__